import { render, staticRenderFns } from "./IncidenceSelect.vue?vue&type=template&id=2b00b8e2&scoped=true"
import script from "./IncidenceSelect.vue?vue&type=script&lang=js"
export * from "./IncidenceSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b00b8e2",
  null
  
)

export default component.exports